export function canShowIncidentButton(
  selectedTab: string,
  selectedItems: any[]
) {
  const validSelectedTab = [
    "shipment_status_in_transit",
    "shipment_status_delivered",
    "all"
  ].includes(selectedTab);
  if (!validSelectedTab) return false;

  if (selectedItems.length !== 1) return false;

  const shipmentSelected = selectedItems[0];
  if (!["CREATED", "INVOICED"].includes(shipmentSelected.status)) return false;

  return !shipmentSelected.hasIncident;
}
